__turbopack_context__.v({
  "content": "GasTrackerPage-module__gMQxaW__content",
  "emptyState": "GasTrackerPage-module__gMQxaW__emptyState",
  "header": "GasTrackerPage-module__gMQxaW__header",
  "subtitle": "GasTrackerPage-module__gMQxaW__subtitle",
  "title": "GasTrackerPage-module__gMQxaW__title",
});
